/* global MatgenGlobal */

const loaders = {
  TemplateTable: () =>
    import(/* webpackChunkName: "table-templates" */ './TemplateTable.js'),
  TenantTable: () =>
    import(/* webpackChunkName: "table-tenants" */ './TenantTable.js'),
  QuestionnaireTable: () =>
    import(
      /* webpackChunkName: "table-questionnaires" */ './QuestionnaireTable.js'
    ),
  SectionsTable: () =>
    import(/* webpackChunkName: "table-sections" */ './SectionsTable.js'),
  QuestionsTable: () =>
    import(/* webpackChunkName: "table-questions" */ './QuestionsTable.js'),
  AnswersTable: () =>
    import(/* webpackChunkName: "table-answers" */ './AnswersTable.js'),
  MaterialTable: () =>
    import(/* webpackChunkName: "table-materials" */ './MaterialTable.js'),
  MicrositeTable: () =>
    import(/* webpackChunkName: "table-microsites" */ './MicrositeTable.js'),
  MaterialTemplateTable: () =>
    import(
      /* webpackChunkName: "table-material-templates" */ './MaterialTemplateTable.js'
    ),
  UserTable: () =>
    import(/* webpackChunkName: "table-users" */ './UserTable.js'),
  TemplateSummaryTable: () =>
    import(
      /* webpackChunkName: "table-template-summary" */ './TemplateSummaryTable.js'
    ),
  CognitoAgreementReportTable: () =>
    import(
      /* webpackChunkName: "report-agreements" */ './CognitoAgreementReportTable.js'
    ),
};

const pendingLoads = {};

async function loadTable(name) {
  if (MatgenGlobal.Tables[name]) {
    return MatgenGlobal.Tables[name];
  }

  if (!loaders[name]) {
    throw new Error(`Unknown table module: ${name}`);
  }

  if (!pendingLoads[name]) {
    pendingLoads[name] = loaders[name]().then(module => {
      const table = module[name];
      if (!table) {
        throw new Error(`Table module did not export ${name}`);
      }
      MatgenGlobal.Tables[name] = table;
      return table;
    });
  }

  try {
    return await pendingLoads[name];
  } catch (error) {
    delete pendingLoads[name];
    throw error;
  }
}

export { loadTable };
